import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import './CompleteProfile.css';
import NeighbourSidebar from "../../NeighbourSidebar";
import Header from "../../NeighbourHeaderAfterLogin";
import Footer from "../../FooterAfterLogin";
import loader from '../../../assests/loader.gif';
import API from '../../../Utils/Api';

import {validatecompleteprofile} from '../../../Utils/validate';
import { gettoastwarning,gettoastsuccess } from '../../../Utils/Common';

const CompleteProfile = () => {


    const [loading,setLoading] = useState(true);
    
    const [errors,setErrors] = useState({});
    const [inputs,setInputs] = useState({first_name:'',last_name:'',email:'',contact_number:'', pincode: '', state: '', city: '', town: ''});

    const [state, setState] = useState([]);
    const [city, setCity] = useState([]);
    const [town, setTown] = useState([]);

    useEffect(() => {
        document.title = `Edit Profile | Local Bells`;
        document.getElementById('bodywrap').className = 'needitprof';

        /* Start get profile */
            API.get('get_user_detail')
                .then(response => {
                    setLoading(false);
                if(response.data.status === false){
                    
                }else{
                  setInputs({
                    first_name:response.data.data.first_name,
                    last_name:response.data.data.last_name,
                    email:response.data.data.email,
                    contact_number:response.data.data.contact_number,
                    pincode: response.data.data.pincode,
                    state: response.data.data.state,
                    city: response.data.data.city,
                    town: response.data.data.town,
                  });

                  getCitySel(response.data.data.state);
                  getTownSel(response.data.data.city);

                }                  
            }).catch(error => {
                setLoading(false); 
            });  
        /* End get profile */

        API.post('get_state')
            .then(response => {
                setState(response.data.data);
            });

    }, []);

    const getCitySel = (state_id) => {
        let formData = new FormData();
        formData.append('state_id', state_id);
        API.post('get_city', formData)
            .then(response => {

                if (response.data.status === true) {
                    setCity(response.data.data);
                } else {


                }
            }).catch(error => {

            });

    }

    const getTownSel = (city_id) => {
        let formData = new FormData();
        formData.append('city_id', city_id);
        API.post('get_town', formData)
            .then(response => {

                if (response.data.status === true) {
                    setTown(response.data.data);
                } else {


                }
            }).catch(error => {

            });
    }
    const getpicode_town = () => {
        if (inputs.pincode !== '') {
            let formData = new FormData();
            formData.append('pin_code', inputs.pincode);
            API.post('get_pincode_town', formData)
                .then(response => {

                    if (response.data.status === true) {
                        if (response.data.data.city_id !== '' && response.data.data.state_id !== '') {
                            setCity(response.data.data.city);
                            setTown(response.data.data.town);
                            var state_label = 'state';
                            var state = response.data.data.state_id;
                            setInputs(inputs => ({ ...inputs, [state_label]: state }));

                            var city_label = 'city';
                            var city = response.data.data.city_id;
                            setInputs(inputs => ({ ...inputs, [city_label]: city }));

                            var town_label = 'town';
                            var town = response.data.data.town_id;
                            setInputs(inputs => ({ ...inputs, [town_label]: town }));
                        }else{
                            setCity([]);
                            setTown([]);
                            var state_label1 = 'state';
                            var state1 = '';
                            setInputs(inputs => ({ ...inputs, [state_label1]: state1 }));

                            var city_label1 = 'city';
                            var city1 = '';
                            setInputs(inputs => ({ ...inputs, [city_label1]: city1 }));

                            var town_label1 = 'town';
                            var town1 = '';
                            setInputs(inputs => ({ ...inputs, [town_label1]: town1 }));
                        }
                    } else {

                    }
                }).catch(error => {

                });
        }
    }
    const getCity = (event) => {
        event.preventDefault();
        setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));

        setTown([]);

        var st = 'city';
        var st_val = '';
        setInputs(inputs => ({ ...inputs, [st]: st_val }));

        var ct = 'town';
        var ct_val = '';
        setInputs(inputs => ({ ...inputs, [ct]: ct_val }));

        var ctt = 'category_id';
        var ctt_val = '';
        setInputs(inputs => ({ ...inputs, [ctt]: ctt_val }));

        let formData = new FormData();
        formData.append('state_id', event.target.value);
        API.post('get_city', formData)
            .then(response => {

                if (response.data.status === true) {
                    setCity(response.data.data);
                } else {


                }
            }).catch(error => {

            });

    }

    const getTown = (event) => {
        event.preventDefault();
        setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));
        setTown([]);

        var ct = 'town';
        var ct_val = '';
        setInputs(inputs => ({ ...inputs, [ct]: ct_val }));

        var ctt = 'category_id';
        var ctt_val = '';
        setInputs(inputs => ({ ...inputs, [ctt]: ctt_val }));
        let formData = new FormData();
        formData.append('city_id', event.target.value);
        API.post('get_town', formData)
            .then(response => {

                if (response.data.status === true) {
                    setTown(response.data.data);
                    var ct1 = 'town';
                  var ct_val1 = response.data.extra_data.town_id;
                  setInputs(inputs => ({ ...inputs, [ct1]: ct_val1 }));

                  var pin1 = 'pincode';
                  var pin_val1 = response.data.extra_data.pincode;
                  setInputs(inputs => ({ ...inputs, [pin1]: pin_val1 }));
                } else {


                }
            }).catch(error => {

            });
    }
    const getCat = (event) => {
        event.preventDefault();
        setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));
        get_town_picode(event.target.value);
    }
    const get_town_picode = (id) => {
        let formData = new FormData();
        formData.append('town_id', id);
        API.post('get_town_pincode', formData)
            .then(response => {

                if (response.data.status === true) {
                    if (response.data.data.city_id !== '') {
                        var pincode_label = 'pincode';
                        var pincode_val = response.data.data.pincode;
                        setInputs(inputs => ({ ...inputs, [pincode_label]: pincode_val }));
                    }
                } else {

                }
            }).catch(error => {

            });
    }

    // State to toggle sidebar visibility
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);

    // Function to toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarVisible((prev) => !prev);
    };

    const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validatecompleteprofile(inputs);
     const noErrors = Object.keys(validationErrors).length === 0;
        setErrors({});
        setErrors(validationErrors);
        
        if(noErrors){
                setLoading(true);
            
            let formData = new FormData(); 
            Object.keys(inputs).forEach((key) => {
            formData.append(key, inputs[key]);
        });
            API.post('update_neighbor_profile', formData)
              .then(response => {
              if(response.data.status === false){
                //setError(response.data.message);
                

                setLoading(false); 
                gettoastwarning(response.data.message,'');
              }else{
                 setLoading(false);
                 var is_profile_verify2=1;
                    localStorage.setItem("is_profile_verify", is_profile_verify2);

                    localStorage.setItem("location_id", response.data.data.location_id);
                localStorage.setItem("location_town", response.data.data.location_town_name);
            
                var loc = '';
                if (response.data.data.location_pincode !== '' && response.data.data.location_town_name !== '') {
                    loc = `${response.data.data.location_town_name} - ${response.data.data.location_pincode}`;
                }
                localStorage.setItem("location", loc);
                    
                 gettoastsuccess(response.data.message,'/neighbour/local-deals');
              }                  
            }).catch(error => {
               setLoading(false);
               gettoastwarning("Something went wrong. Please try again later.",'');
                //setError("Something went wrong. Please try again later.");
            });
        }
    //navigate('/neighbour/login');
  };
/* Start Value set */
const handleInputChangeMo = (event) => {
  event.persist();
  const { name, value } = event.target;

  // Allow only numbers (0–9)
  const regex = /^[0-9]*$/;

  if (regex.test(value)) {
    setInputs(inputs => ({ ...inputs, [name]: value }));
  }      
}
const handleInputChangeSpe = (event) => {
  event.persist();
  const { name, value } = event.target;

  // Allow only letters, numbers, spaces, and basic punctuation if needed
  const regex = /^[a-zA-Z0-9\s]*$/;

  if (regex.test(value)) {
    setInputs(inputs => ({ ...inputs, [name]: value }));
  }    
}
/* End Value set */



    return (
        <>
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <NeighbourSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible} />
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>
                            <Header toggleSidebar={toggleSidebar} />  
                            <div className='nei-cont'>
                                <Row>
                                    <Col md={8} lg={8} xl={7} xxl={5}>
                                        <div className='white-box edpf-box'>
                                            <div className="d-flex align-items-start justify-content-between gap-3">                                               
                                                <h3 className='mb-3'>Complete Your Profile</h3>
                                                
                                            </div>                                            
                                            <Form onSubmit={handleSubmit}>
                                                <Row>
                                                    <Col md={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label className=''>First Name</Form.Label>
                                                            <Form.Control type="text" placeholder="First Name" name="first_name" onChange={handleInputChangeSpe} value={inputs.first_name} />
                                                            {errors.first_name && (<p className="text-danger">{errors.first_name}</p>)}
                                                        </Form.Group>                                                    
                                                    </Col>
                                                    <Col md={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label className=''>Last Name</Form.Label>
                                                            <Form.Control type="text" placeholder="Last Name" name="last_name" onChange={handleInputChangeSpe} value={inputs.last_name} />
                                                            {errors.last_name && (<p className="text-danger">{errors.last_name}</p>)}
                                                        </Form.Group>                                                    
                                                    </Col>
                                                </Row>

                                                <Form.Group className="mb-3">
                                                    <Form.Label className=''>Your Email</Form.Label>
                                                    <Form.Control type="email" placeholder="Your Email" value={inputs.email}  disabled/>
                                                </Form.Group>

                                                <Form.Group className="mb-3">
                                                    <Form.Label className=''>Phone number</Form.Label>
                                                    <Form.Control type="text" placeholder="Contact number" name="contact_number" onChange={handleInputChangeMo} value={inputs.contact_number} maxLength={15} />
                                                    {errors.contact_number && (<p className="text-danger">{errors.contact_number}</p>)}
                                                </Form.Group>

                                                <Form.Group className="mb-3">
                                                    <Form.Label className='d-none'>Pin code</Form.Label>
                                                    <Form.Control type="text" placeholder="Pin code" name="pincode" onChange={handleInputChangeMo} onBlur={getpicode_town} value={inputs.pincode} maxLength={6} />
                                                    {errors.pincode && (<p className="text-danger">{errors.pincode}</p>)}
                                                </Form.Group>                                          

                                                <Row>
                                                    <Col md={4}>
                                                        <Form.Select aria-label="Default select example" name="state" onChange={getCity} value={inputs.state}>
                                                            <option value="">State</option>
                                                            {state && state.map((val, index) => {
                                                                return (
                                                                    <option value={val.id}>{val.name}</option>
                                                                )
                                                            })}
                                                        </Form.Select>	 
                                                        {errors.state && (<p className="text-danger">{errors.state}</p>)}                                                  
                                                    </Col>
                                                    <Col md={4}>
                                                        <Form.Select aria-label="Default select example" name="city" onChange={getTown} value={inputs.city}>
                                                            <option value="">City</option>
                                                            {city && city.map((val, index) => {
                                                                return (
                                                                    <option value={val.id}>{val.name}</option>
                                                                )
                                                            })}
                                                        </Form.Select>	
                                                        {errors.city && (<p className="text-danger">{errors.city}</p>)}                                                     
                                                    </Col>
                                                    <Col md={4}>
                                                        <Form.Select aria-label="Default select example" name="town" onChange={getCat} value={inputs.town}>
                                                            <option value="">Locality</option>
                                                            {town && town.map((val, index) => {
                                                                return (
                                                                    <option value={val.id}>{val.name}</option>
                                                                )
                                                            })}											
                                                        </Form.Select>	    
                                                        {errors.town && (<p className="text-danger">{errors.town}</p>)}                                                
                                                    </Col>
                                                </Row>                                                                                                              
                                                <Button type="submit" className='blue-btn'>Save profile</Button>
                                            </Form>                                             
                                        </div>
                                    </Col>
                                </Row>
                                <div className='footer-main footer'>
                                    <Footer />                                
                                </div>                                    
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            {loading && (
               <div className="loadingClass">
                <img src={loader} alt="loader"/>
              </div>
               )}
        </>
    )
}

export default CompleteProfile;


